import React from 'react';
import { HashRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import PwaInstallPrompt from './components/PwaInstallPrompt';
import PwaNetworkStatus from './components/PwaNetworkStatus';
import PwaUpdatePrompt from './components/PwaUpdatePrompt';
import PwaPushPrompt from './components/PwaPushPrompt';
import { AuthProvider, useAuth } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import Dashboard from './pages/Dashboard';
import ForcePasswordChange from './pages/ForcePasswordChange';
import Invoices from './pages/Invoices';
import Loans from './pages/Loans';
import Login from './pages/Login';
import Schedules from './pages/Schedules';
import Tasks from './pages/Tasks';
import Team from './pages/Team';

function AppRoutes() {
  const { currentUser, isAuthenticated, login } = useAuth();

  if (!isAuthenticated) {
    return <Login onLoginSuccess={login} />;
  }

  if (currentUser?.mustChangePassword) {
    return <ForcePasswordChange />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route
          path="/invoices"
          element={
            <ProtectedRoute requiredPermission="invoices">
              <Invoices />
            </ProtectedRoute>
          }
        />
        <Route
          path="/loans"
          element={
            <ProtectedRoute requiredPermission="loans">
              <Loans />
            </ProtectedRoute>
          }
        />
        <Route
          path="/schedules"
          element={
            <ProtectedRoute requiredPermission="schedules">
              <Schedules />
            </ProtectedRoute>
          }
        />
        <Route
          path="/requests"
          element={
            <ProtectedRoute requiredPermission="tasks">
              <Tasks />
            </ProtectedRoute>
          }
        />
        <Route path="/tasks" element={<Navigate to="/requests" replace />} />
        <Route
          path="/team"
          element={
            <ProtectedRoute requiredPermission="team">
              <Team />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Router>
          <AppRoutes />
        </Router>
        <PwaNetworkStatus />
        <PwaInstallPrompt />
        <PwaUpdatePrompt />
        <PwaPushPrompt />
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
